import React, { Fragment, useEffect } from 'react';

function RemoveAuthModule() {
    useEffect(() => {
        document.querySelectorAll('#auth-under-menu').forEach(val => val.remove());
        document.querySelectorAll('#auth-in-menu').forEach(val => val.remove());
        document.querySelector('#auth-module').remove();

    }, [])

    return (
        <Fragment></Fragment>
    )
}

export default RemoveAuthModule;